// extracted by mini-css-extract-plugin
export default {"description":"style_description__IXYQ6","fade-in":"style_fade-in__P4XGJ","top":"style_top__HfunT","image":"style_image__H1FUw"};